import { useAppNotifications } from "@/hooks/useAppNotifications";
import { TOAST_AUTO_HIDE_DURATION } from "@/constants";
import { useAccount } from "@/context/account";
import { gql } from "@/gql";
import { showErrorToast } from "@/utils/showErrorToast";
import { useMutation } from "@apollo/client/react";

import { useTranslation } from "react-i18next";

const UPDATE_LICENSE_AUTO_REVOKE = gql(`
  mutation UpdateLicenseAutoRevoke($customerAccountId: ID!, $dealerAccountId: ID!, $licenseId: ID!, $revokeAtCheckIn: Boolean!) {
    updateLicenseAutoRevoke(customerAccountId: $customerAccountId, dealerAccountId: $dealerAccountId, licenseId: $licenseId, revokeAtCheckIn: $revokeAtCheckIn) {
      __typename
      ... on License {
        id
        holderId
      }
      ... on OfflineLicense {
        id
        checkInDate
        checkOutDate
        holderId
        revokeWhenOnline
      }
    }
  }
`);

const useUpdateLicenseAutoRevoke = () => {
  const { t } = useTranslation();
  const { account } = useAccount();
  const notifications = useAppNotifications();

  return useMutation(UPDATE_LICENSE_AUTO_REVOKE, {
    variables: {
      dealerAccountId: account.id,
    },
    onCompleted: () => {
      notifications.show(t("devices.manage_device_modal.auto_revoke_updated"), {
        severity: "success",
        autoHideDuration: TOAST_AUTO_HIDE_DURATION,
      });
    },
    onError: (error) => {
      showErrorToast(
        notifications,
        error,
        t("devices.manage_device_modal.auto_revoke_failed", {
          message: error.message,
        })
      );
    },
  });
};

export { useUpdateLicenseAutoRevoke };
